import { Button, ButtonProps } from "@chakra-ui/react";
import { forwardRef, useContext } from "react";
import { useIntl } from "react-intl";

import { getErrorArray } from "../../utils/get-errors";
import { useRanaFormIsValid } from "../hooks/use-rana-form-is-valid";
import { RanaFormContext } from "../rana-form";

export const RanaFormSubmitButton = forwardRef<HTMLButtonElement, ButtonProps>(
  function RanaFormSubmitButton({ isDisabled, ...rest }: ButtonProps, ref) {
    const intl = useIntl();
    const { errors, submitting, onSubmit } = useContext(RanaFormContext);
    const ranaFormIsValid = useRanaFormIsValid();
    const isActuallyDisabled =
      isDisabled || submitting || getErrorArray(errors).length > 0 || !ranaFormIsValid;

    return (
      <Button
        ref={ref}
        onClick={onSubmit}
        title={
          !ranaFormIsValid
            ? intl.formatMessage({
                id: "submit.not_all_required_fields_filled",
                defaultMessage: "Not all required fields are filled in",
              })
            : undefined
        }
        isDisabled={isActuallyDisabled}
        variant="primary"
        {...rest}
      />
    );
  }
);
